import { render } from "./CatalogSubcategories.vue?vue&type=template&id=1462c788&scoped=true"
import script from "./CatalogSubcategories.vue?vue&type=script&lang=js"
export * from "./CatalogSubcategories.vue?vue&type=script&lang=js"

import "./CatalogSubcategories.vue?vue&type=style&index=0&id=1462c788&scoped=true&lang=css"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1462c788"]])

export default __exports__